export const MOXO_CONTAINER_ID = () => '#moxo-chat';
